import React from "react";

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const IconArrowRight = ({
  width = 24,
  height = 24,
  color = "black",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.96989 4.60834C9.67699 4.90123 9.67699 5.37611 9.96989 5.669L13.5507 9.24979H5.63911C5.22489 9.24979 4.88911 9.58558 4.88911 9.99979C4.88911 10.414 5.22489 10.7498 5.63911 10.7498H13.5507L9.96989 14.3306C9.67699 14.6235 9.67699 15.0983 9.96989 15.3912C10.2628 15.6841 10.7377 15.6841 11.0305 15.3912L15.8917 10.5301C16.1846 10.2372 16.1846 9.76236 15.8917 9.46946L11.0305 4.60834C10.7377 4.31545 10.2628 4.31545 9.96989 4.60834Z"
        fill={color}
      />
    </svg>
  );
};

IconArrowRight.displayName = "IconArrowRight";

export default IconArrowRight;
